import { render, staticRenderFns } from "./el-popconfirm.vue?vue&type=template&id=6375d17a"
import script from "./el-popconfirm.vue?vue&type=script&lang=js"
export * from "./el-popconfirm.vue?vue&type=script&lang=js"
import style0 from "./el-popconfirm.vue?vue&type=style&index=0&id=6375d17a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports